import { render, staticRenderFns } from "./Karin-report-excel.vue?vue&type=template&id=2c870d0d"
import script from "./Karin-report-excel.vue?vue&type=script&lang=js"
export * from "./Karin-report-excel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports